/**
 * Navigate the user outside of AMUI
 * We use this instead of directly calling window.location.assign so that we
 * can mock it in stories.
 *
 * WARN: Do not use this for internal AMUI navigation unless you know you need
 * it. Use client-side navigation instead.
 */
export function assignLocation(url: string) {
  window.location.assign(url);
}
